import { ContactApi } from "@services/generated";
import api from "services/api";
import { handleErrors } from "services/helpers";
import { rootApi } from "store/root-api";
import appUrls from "utils/app-urls";

const API_URL = appUrls.getEndpointUrl();

const contactsClient = new ContactApi(
    undefined,
    new URL(API_URL, process.env.REACT_API_URL).href,
    api,
);


const leadsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getStocksFromLead: builder.query<string[], void>({
            queryFn: () => handleErrors(() => contactsClient.getStocksFromLead()),
            providesTags: [{ type: 'Leads' }],
        }),
        addStockToLead: builder.mutation<void, string>({
            queryFn: (stock) => handleErrors(() => contactsClient.addStockToLead(stock)),
            invalidatesTags: [{ type: 'Leads' }],
            onQueryStarted(productCode, { dispatch, queryFulfilled }) {
                // Optimistically update the query data so that changes are reflected immediately
                const patchResult = dispatch(
                    leadsApi.util.updateQueryData('getStocksFromLead', undefined, (draft) => [...draft, productCode])
                )

                queryFulfilled.catch(patchResult.undo);
            },
        }),
    }),
});

export const { useGetStocksFromLeadQuery, useAddStockToLeadMutation } = leadsApi;